import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { fetchUserFeatures } from "../../actions/featureAccessActions";

class FeatureLock extends React.Component {
  componentDidMount() {
    if (!this.props.loaded && !this.props.loading) {
      this.props.fetchUserFeatures();
    }
  }

  isFeatureEnabled = () => {
    const { featureId, features } = this.props;
    const feature = features.find((f) => f.feature_id === featureId);
    return feature ? feature.status === "E" : false;
  };

  render() {
    const { children, loading, loaded, maskContent, lockedPlaceholder } = this.props;

    if (loading || !loaded) {
      return children;
    }

    if (this.isFeatureEnabled()) {
      return children;
    }

    const lockedBody = maskContent ? (
      lockedPlaceholder || (
        <div
          style={{
            minHeight: 200,
            background: "#f0f2f5",
            borderRadius: 8,
            border: "1px dashed #d0d5dd",
          }}
          aria-hidden="true"
        />
      )
    ) : (
      <div
        style={{
          opacity: 0.45,
          pointerEvents: "none",
          userSelect: "none",
        }}
      >
        {children}
      </div>
    );

    return (
      <div style={{ position: "relative", display: "inline-block", width: "100%" }}>
        {lockedBody}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            zIndex: 10,
          }}
        >
          <Link
            to="/admin/manage-subscription"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textDecoration: "none",
              color: "#333",
            }}
          >
            <div
              style={{
                width: 40,
                height: 40,
                borderRadius: "50%",
                background: "rgba(240, 147, 43, 0.15)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: 6,
              }}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#f0932b"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
              </svg>
            </div>
            <span
              style={{
                fontSize: 11,
                fontWeight: 600,
                color: "#f0932b",
                textAlign: "center",
                lineHeight: 1.3,
              }}
            >
              Upgrade to unlock
            </span>
          </Link>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.featureAccess.loading,
  loaded: state.featureAccess.loaded,
  features: state.featureAccess.features,
});

export default connect(mapStateToProps, { fetchUserFeatures })(FeatureLock);
